<template>
  <div class="ws-links">
    <div class="ws-links__heading">Linked tags <span v-if="tags.length">({{ tags.length }})</span></div>
    <div v-if="!tagIds.length" class="ws-links__empty">This document is not linked to any tag.</div>
    <div v-else class="ws-links__chips">
      <v-chip v-for="tag in tags" :key="tag.id" small outlined :title="tag.name">
        <v-icon x-small left>mdi-tag-outline</v-icon>
        {{ tag.name }}
      </v-chip>
    </div>
    <div v-if="unresolved" class="ws-links__note">
      {{ unresolved }} linked {{ unresolved === 1 ? 'tag is' : 'tags are' }} not loaded in this facility.
    </div>
  </div>
</template>

<script>
  /** Tags the document is linked to (`forgeTagsIds`), named from the tags already in the store. */
  export default {
    name: 'WorkspaceLinksTab',
    props: {
      document: { type: Object, required: true },
    },
    computed: {
      allTags() {
        return this.$store.getters.GET_ALL_EXISTING_TAGS || [];
      },
      tagIds() {
        return this.document.forgeTagsIds || [];
      },
      tags() {
        const wanted = new Set(this.tagIds);
        return this.allTags.filter((tag) => wanted.has(tag.id)).sort((a, b) => String(a.name).localeCompare(String(b.name)));
      },
      unresolved() {
        return Math.max(0, this.tagIds.length - this.tags.length);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ws-links {
    padding: 12px 16px;
  }

  .ws-links__heading {
    font-size: var(--ds-font-caption, 12px);
    font-weight: 600;
    opacity: 0.75;
    margin-bottom: 8px;
  }

  .ws-links__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .ws-links__empty,
  .ws-links__note {
    font-size: var(--ds-font-body-sm, 13px);
    opacity: 0.75;
  }

  .ws-links__note {
    margin-top: 10px;
  }
</style>
